import cx from 'classnames';
import * as React from 'react';

import Heading from 'components/Heading';
import Text from 'components/Text';

export type Props = {
  children?: string | React.ReactElement;
  className?: string;
  subtext?: string | React.ReactElement;
  subtle?: boolean;
};

export default function TextWithSubtext(props: Props) {
  const { children, className, subtext, subtle } = props;

  return (
    <div className={cx('TextWithSubtext', className)}>
      {subtle ? (
        <Text element="div" size="small" truncate>
          {children}
        </Text>
      ) : (
        <Heading flush level="2" levelStyle="5">
          <Text truncate>{children}</Text>
        </Heading>
      )}
      {subtext && (
        <Text color="thunder" size="xxsmall" truncate>
          {subtext}
        </Text>
      )}
    </div>
  );
}
